/* 1.引入axios */
import axios from "axios";
import store from "@/store";
import router from "@/router";
import Vue from "vue";
import qs from "qs"; //引入 node中自带的qs模块（数据格式转换）
/* 2.全局默认配置 */
let baseURL;
// 判断开发环境（一般用于本地代理）
if (process.env.NODE_ENV === "development") {
  // 开发环境
  baseURL = glodApi.devUrl;
} else {
  // 编译环境
  baseURL = glodApi.baseUrl;
}
import { Message, MessageBox } from "element-ui";
const CancelToken = axios.CancelToken;
Vue.$httpRequestList = [];
/* 3.配置axios属性 */
const Axios = axios.create({
  // 后台服务地址
  baseURL: baseURL,
  // 请求超时时间1分钟
  timeout: 60000,
  // 是否允许带cookie
  withCredentials: false,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

/* 4.请求拦截器 */
Axios.interceptors.request.use(
  (config) => {
    // 发送请求前进行拦截
    if (config.method == "post" || config.method == "put") {
      // //请求头，JSON形式传送
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      //转换为JSON数据
      if (config.data.Params) {
        config.data.Params = JSON.stringify(config.data.Params);
      }
      config.data = qs.stringify(config.data);
    }

    //携带token
    if (localStorage.getItem("token")) {
      config.headers.Authorization = localStorage.getItem("token");
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/* 5.响应拦截器 */
Axios.interceptors.response.use(
  (res) => {
    let data = qs.parse(res.config.data);
    let code = res.data.ReturnCode;
    let api = res.config.url;
    // if (code == 0 || api == "/Login/ShowValidateCode") {
    //   //正常运行
    //   return res.data;
    // }
    //未登录系统
    if (code == -1001) {
      if (data.ClientName == "Hoko.Iot.Web.System") {
        router.push("/adminLogin");
      } else {
        router.push("/");
      }
      //直接阻止向下运行
      Message.error("未登录系统");
      return Promise.reject(res);
    }else if(code == -1002){
      if (data.ClientName == "Hoko.Iot.Web.System") {
        router.push("/adminLogin");
      } else {
        router.push("/");
      }
      //直接阻止向下运行
      Message.error("已在其他终端登录");
    }else if(code == -1003){
      if (data.ClientName == "Hoko.Iot.Web.System") {
        router.push("/adminLogin");
      } else {
        router.push("/");
      }
      //直接阻止向下运行
      Message.error("登录已超时");
    } else {
      return res.data;
    }
  },
  (err) => {
    return Promise.reject(err);
  }
);

// function axios_http(api, data, type = 'post', requestLocation) {
// 	let sendRequest
// 	//POST请求
// 	if (type == 'POST' || type == 'post' || type == 'put' || type == "PUT") {
// 		sendRequest = Axios({
// 			url: api,
// 			method: type,
// 			data: data,
// 			cancelToken: new CancelToken(c => { //强行中断请求要用到的
// 				Vue.$httpRequestList.push(c);
// 			})
// 		})
// 	}
// 	//DELETE请求
// 	else if (type == 'delete' || type == 'DELETE') {
// 		if (requestLocation == 'url') {
// 			sendRequest = Axios({
// 				url: api,
// 				method: type,
// 				params: data
// 			})
// 		} else {
// 			sendRequest = Axios({
// 				url: api,
// 				method: type,
// 				data: data
// 			})
// 		}
// 	}
// 	//GET请求
// 	else {
// 		sendRequest = Axios({
// 			url: api,
// 			method: type,
// 			params: data,
// 			cancelToken: new CancelToken(c => { //强行中断请求要用到的
// 				Vue.$httpRequestList.push(c);
// 			})
// 		})
// 	}
// 	return new Promise((resolve, reject) => {
// 		sendRequest.then(res => {
// 			resolve(res);
// 		}).catch(error => { //中断请求和请求出错的处理
// 			if (error.message == "interrupt") {
// 				return;
// 			} else {
// 				reject(error);
// 			}
// 		})
// 	})
// }

function axios_http(api, data, type = "post") {
  if (type == "post" || type == "POST") {
    return Axios({
      url: api,
      method: type,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded", //设置请求头请求格式form
      },
      data: data,
    });
  } else {
    return Axios({
      url: api,
      method: type,
      data: data,
    });
  }
}
/* 6.暴露实例 */
export default {
  axios_http,
};
